import sileo from 'sileo';

const Resumes = new sileo.Model('bposeats', 'applicant-resumes');
const ResumeDetail = new sileo.Model('bposeats', 'applicant-specific-resume');
const TeamBuilderLeadCard = new sileo.Model('hqzen', 'team-builder-lead-cards');


const actions = {
    async fetchResumes(context, filters) {
        return await Resumes.objects.filter(filters);
    },

    fetchResumeDetails(context, pk) {
        return ResumeDetail.objects.get(pk);
    },

    createIntialLeadCard(_, data) {
        return TeamBuilderLeadCard.objects.create(data)
    },

    finalizeLeadCard(_, payload) {
        const filters = payload.filters;
        const data = payload.data
        return TeamBuilderLeadCard.objects.update(filters, data)
    }
};

export default {
	namespaced: true,
	actions
};
